import { RouterModule, Routes } from '@angular/router';

import * as pages from '../pages/pages';
import * as providers from '../providers/providers';

const AppRoutes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'dashboard', component: pages.HomePage, canActivate: [ providers.Guard ] },
  { path: 'account', component: pages.AccountPage, canActivate: [ providers.Guard ] },
  { path: '**', redirectTo: '/dashboard', pathMatch: 'full' },
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});



// WEBPACK FOOTER //
// /builds/mediaclinicstn/stampling-viewer/src/app/app.routing.module.ts